import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  standalone: true,
  selector: 'lx-card-skeleton',
  templateUrl: './card-skeleton.component.html',
  styleUrls: ['./card-skeleton.component.scss'],
  imports: [SkeletonModule],
})
export class CardSkeletonComponent {
  // Optional custom height for the main skeleton block.
  @Input() bodyHeight = '12rem';
}
